import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createMeeting } from "./api";
import { queryClient } from "utils/react-query";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { participants, ...rest } = values;

    const payload = {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
        starts_at: values.starts_at || null,
        ends_at: values.ends_at || null,
    };

    // Format participants for creation
    if (participants && participants.length > 0) {
        payload.participants = {
            create: participants.map(p => ({
                participant: {
                    email: p.email
                }
            }))
        };
    }

    return payload;
}

export function useCreateMeeting() {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values);
            const response = await createMeeting({ item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Meeting Created Successfully");
            queryClient.invalidateQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.error(error);
        },
    });
}
